export default {
	weldMode: {
		selectFacesPrompt: "Select the faces to be welded.",
		weldlineLabel: "Weld seam",
		selectFacePrompt: "Select a face...",
		selectMoreFacesPrompt: "Select more faces or apply...",
		helpLink: "Help",
		applyButtonTitle: "Create the selected weld seams.",
		applyButton: "Apply",
		maxDistanceFallback: "the maximum permitted distance between the materials",
		someWeldsFailedMessage:
			"The algorithm cannot find a way to create a weld seam between certain faces. " +
			"Make sure the distance between the faces does not exceed {distance} and that the edges are parallel.",
		errorListIntro: "The individual error messages are listed below:",
		someWeldsFailedTitle: "Some weld seams could not be defined.",
		weldDefinitionFailedTitle: "Weld seam cannot be defined.",
	},
	weldlines: {
		existingWeldlinesTitle: "Existing weld seams",
		cleanAllCheckboxLabel: "Clean up all weld seams",
		weldlineLabel: "Weld seam",
		fillerLabel: "fill",
		pluggedLabel: "plugged",
		withCornersLabel: "with",
		cornerLabel: "Corner",
		cornerTooltipChoose: "Please select whether this corner should be welded or not.",
		cornerTooltipTooLarge: "This corner is too large to be welded. Please note our",
		cornerTooltipConstructionLink: "design guideline.",
		defineSegmentsTitle: "Define pattern",
		deleteWeldlineTitle: "Delete weld seam",
		segmentDialogTitle: "Split weld seam into segments.",
		segmentDialogInfo1:
			"The weld seam can be welded along its full length. This results in high strength but also " +
			"a high heat input, which can cause the part to warp.",
		segmentDialogInfo2:
			"If you split the weld seam into segments and keep the segments short, you can counteract this effect.",
		numberOfSegmentsLabel: "Number of segments:",
		segmentLengthLabel: "Length of a segment [mm]:",
		singleSegmentInfo:
			"If only one segment is defined, its length is automatically set to match the length of the weld seam.",
		applyButton: "Apply",
		cancelButton: "Cancel",
		errorSegmentsMustBeInteger: "The number of segments must be a whole number.",
		errorSegmentsMinOne: "The number of segments must be at least 1.",
		errorSegmentMinLength: "A segment must be at least 5 mm long.",
		errorSegmentsTotalTooLong:
			"The total length of the segments is longer than the weld seam. " +
			"Also note that at least 5 mm must remain between segments.",
	},
	rollDirectionMode: {
		noDirectionDefined: "No roll direction has been defined yet. Select an outer edge for the roll direction.",
		adjustHint:
			"You can define the course of the roll direction by changing the angle or clicking on another outer edge.",
		angleRangeLabel: "(0° to 180°)",
	},
	measuringMode: {
		selectPrompt: "Select faces or edges to measure.",
	},
};
